if (!customElements.get('v5-life-style')) {
  class v5LifeStyle extends HTMLElement {
    constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.num = 0;
    }
    
    connectedCallback() {
      this.init();
    }
    init() {
        this.num = Number(this.getAttribute('data-num') || 0)
        if (this.isMobile) {
            if (this.num > 1) this.initSwiper({ slidesPerView: 1.2, spaceBetween: 20, loop: true })
        } else {
            if (this.num > 4) this.initSwiper({ slidesPerView: 4, spaceBetween: 24, loop: true })
        }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy()
        this.swiper = null
      }
    }

    // 初始化swiper
    initSwiper(config = {}) {
      const selector = this.isMobile ? '.v5-life-product-swiper-mb' : '.v5-life-product-swiper-pc'
      const swiperDOM = this.querySelector(selector)
      if(!swiperDOM) return
      
      const nextEl = swiperDOM.querySelector('.swiper-product-button-next')
      const prevEl = swiperDOM.querySelector('.swiper-product-button-prev')
      const navigation = nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}
      
      this.swiper = new Swiper(swiperDOM, Object.assign({ loop: true }, navigation, config));
    }
  }
  customElements.define('v5-life-style', v5LifeStyle);
}
